<template>
  <div class="container-fluid mt-4" style="max-width: 1200px">
    <b-card title="Manage Driver Attributes">
      <form v-if="model" @submit.prevent="saveDriver">
        <table cellpadding="15" cellspacing="15" width="100%" style="font-size: 18px">
          <tr>
            <td align="left" valign="top" nowrap><h5>Name</h5>{{model.name}}</td>
            <td align="left" valign="top" nowrap><h5>Seniority Level</h5>{{model.seniority_level}}</td>
            <td align="left" valign="top"><h5>Driver Score / Rank</h5>{{model.safety_score_30}} / {{model.safety_score_rank_30}}</td>
            <td align="left" valign="top"><h5>Last 30 Days</h5>{{model.hos_driving_hrs_30}} hrs / {{model.hos_distance_miles_30}} miles</td>
          </tr>
          <tr>
            <td colspan="4" align="left" valign="top"><h5>Approved Vehicle Types</h5>
              <template>
                <div align="bottom" style="font-size: 14px">
                  <b-form-checkbox-group
                      v-model="model.vehicle_types"
                      :options="vehicle_type_options"
                  ></b-form-checkbox-group>
                </div>
              </template>
            </td>
<!--            <td colspan="2" align="left" valign="top"><h5>Approved Customer Groups</h5>-->
<!--              <template>-->
<!--                <div align="bottom" style="font-size: 14px">-->
<!--                  <b-form-checkbox-group-->
<!--                      v-model="model.customer_groups"-->
<!--                      :options="customer_group_options"-->
<!--                  ></b-form-checkbox-group>-->
<!--                </div>-->
<!--              </template>-->
<!--            </td>-->
          </tr>
          <tr>
            <td align="left" valign="top" nowrap><h5>Driver Type</h5><b-form-select v-model="model.driver_type" :options="driverTypeOptions"/></td>
            <td align="left" valign="top" nowrap><h5>Late Nights Ok?</h5><b-form-select v-model="model.late_nights" :options="booleanOptions"/></td>
            <td align="left" valign="top" nowrap><h5>Max Days Per Week?</h5><b-form-select v-model="model.max_days_per_week" :options="maxDaysOptions"/></td>
            <td align="left" valign="top" colspan="1"><h5>Available Days Of The Week</h5>
              <template>
                <div align="bottom" style="font-size: 14px">
                  <b-form-checkbox-group
                      v-model="model.week_days"
                      :options="week_day_options"
                  ></b-form-checkbox-group>
                </div>
              </template>
            </td>
          </tr>
          <tr>
            <td align="left" valign="top"><h5>Multiday Ok?</h5><b-form-select v-model="model.multiday" :options="booleanOptions"/></td>
            <td align="left" valign="top"><h5>Holidays Ok?</h5><b-form-select v-model="model.holidays" :options="booleanOptions"/></td>
            <td align="left" valign="top"><h5>Charters Ok?</h5><b-form-select v-model="model.charters" :options="booleanOptions"/></td>
            <td align="left" valign="top"><h5>Line Runs Ok?</h5><b-form-select v-model="model.contracts" :options="booleanOptions"/></td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="2" nowrap><h5>Customers To Avoid (Client IDs from CM)</h5><b-form-input v-model="model.customers_to_avoid" placeholder="Customer1, Customer2"/></td>
            <td align="left" valign="top" colspan="2" nowrap><h5>Preferred Customers (Client IDs from CM)</h5><b-form-input v-model="model.preferred_customers" placeholder="Customer1, Customer2"/></td>
          </tr>
        </table>
        <br/><br/>
        <div>
          <b-btn type="submit" variant="success" id="create-user-submit">Save</b-btn>
          &nbsp;&nbsp;
          <b-btn :to="{ name: 'driver_list_tbn'}">Cancel</b-btn>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>

import {get_driver, update_driver} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'driver_detail',
  components: {  },
  data () {
    return {
      model: {},
      driverTypeOptions: [
        { value: '', text: '' },
        { value: 'full-time', text: 'Full Time' },
        { value: 'part-time', text: 'Part Time' },
        { value: 'casual', text: 'Casual' },
        { value: 'non-driver', text: 'Non Driver' },
        { value: 'leave', text: 'Leave of Absence' },
        { value: 'terminated', text: 'Terminated' },
      ],
      booleanOptions: [
        { value: '', text: '' },
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
      maxDaysOptions: [
        { value: '', text: '' },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' }
      ],
      week_day_options: [
        { value: 'Sunday', text: 'Sunday' },
        { value: 'Monday', text: 'Monday' },
        { value: 'Tuesday', text: 'Tuesday' },
        { value: 'Wednesday', text: 'Wednesday' },
        { value: 'Thursday', text: 'Thursday' },
        { value: 'Friday', text: 'Friday' },
        { value: 'Saturday', text: 'Saturday' },
      ],
      vehicle_type_options: [],
      customer_group_options: [],
    }
  },
  async created() {
    await this.load_data()
  },
  methods: {
    async load_data() {
      try {
        if (this.$route.query.id) {
          const {value: {data: data = []}} = (await get_driver(this.user.tenant, this.$route.query.id))
          this.summary = data.summary
          this.vehicle_type_options = data.summary.vehicle_type_options
          this.customer_group_options = data.summary.customer_group_options
          this.model = data.results
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    async saveDriver () {
      try{
        this.$emit('showAlert', "waiting for response...", 'info')
        const { message, status_code } = await update_driver(this.user.tenant, this.model)
        this.$emit('showAlert', message || 'Success!', 'success', 1500)
        this.$router.push({name:'driver_list'})
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
